// Module-level audio singleton. Scenes import `audio` rather than each
// constructing their own AudioManager — it's per-page state anyway and
// keeps the AudioContext as a single shared resource.
//
// ── Public API ───────────────────────────────────────────────────────────────
//
//   audio.resumeOnGesture(): Promise<void>
//     Call once from any user-gesture handler (pointerdown, keydown …).
//     Creates/resumes the AudioContext. Required before any sound plays.
//
//   audio.playSfx(name: SfxName): void
//     Fire a one-shot SFX. No-ops before resumeOnGesture() or while muted.
//     name: 'ding'      — perfect toast complete (bright chord)
//           'burn'      — marshmallow burnt (crackle + thump)
//           'gameover'  — run ended (descending arpeggio)
//
//   audio.setSizzle(intensity: number): void
//     Drive the continuous sizzle loop. Call every frame.
//     intensity: 0 (silent) … 1 (full volume). Smoothly ramped.
//     Typical usage: audio.setSizzle((1 - distanceNorm) * heatFactor)
//
//   audio.mute(): void
//   audio.unmute(): void
//   audio.toggleMute(): boolean   — returns new muted state
//   audio.isMuted(): boolean

import { AudioManager } from './manager';

export const audio = new AudioManager();

export { AudioManager } from './manager';
export type { SfxName } from './manager';
